import React from 'react';
import UserContext from "../userContext";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";

import Loader from "../Layout/Components/Loader";
import '../styles/main.scss';

export default function Creation() {
    const [password, setPassword] = React.useState('');
    const [verify, setVerify] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState({ type: '', text: '' });

    const userContext = React.useContext(UserContext);
    const history = useHistory();
    const params = useParams();

    const getPasswordStrength = () => {
        if (!password) return '';
        if (password.length < 6) return 'weak';
        if (password.length < 10 || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) return 'medium';
        return 'strong';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        if (password !== verify) {
            setMessage({
                type: 'error',
                text: 'Les mots de passe ne correspondent pas'
            });
            return;
        }

        if (password.length < 6) {
            setMessage({
                type: 'error',
                text: 'Le mot de passe doit contenir au moins 6 caractères'
            });
            return;
        }

        setLoading(true);

        try {
            await userContext.apiReducer('creation', {
                password: password,
                token: params.token
            });

            setLoading(false);
            setMessage({
                type: 'success',
                text: 'Vos accès ont été créés avec succès !'
            });
            setTimeout(() => history.push('/'), 2000);
        } catch (err) {
            setLoading(false);
            console.error(err);

            if (err.message === 'Request failed with status code 405') {
                history.push('/');
            } else {
                setMessage({ type: 'error', text: 'Une erreur est survenue' });
            }
        }
    };

    return (
        <div className="auth-page">
            {/* Animated Background */}
            <div className="auth-background">
                <div className="auth-orb auth-orb--1" />
                <div className="auth-orb auth-orb--2" />
                <div className="auth-orb auth-orb--3" />
            </div>

            {/* Auth Card */}
            <div className="auth-card">
                {/* Logo */}
                <div className="auth-logo">
                    <img
                        src="https://i.ibb.co/3CgD7G4/new-Colors-Logo-2.webp"
                        alt="MYPacôme Logo"
                    />
                    <h1 className="auth-brand">MYPacôme</h1>
                    <p className="auth-tagline">Home Manager</p>
                </div>

                {/* Title */}
                <div className="auth-title">
                    <h2>Bienvenue ! 🎉</h2>
                    <p>Créez votre mot de passe pour accéder à votre espace</p>
                </div>

                {/* Message */}
                {message.text && (
                    <div className={`auth-message ${message.type}`}>
                        {message.text}
                    </div>
                )}

                {/* Form */}
                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label" htmlFor="password">
                            Créer un mot de passe
                        </label>
                        <input
                            type="password"
                            id="password"
                            className="form-input"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="new-password"
                        />
                        {password && (
                            <div className="password-strength">
                                <div className="strength-bar">
                                    <div className={`strength-fill ${getPasswordStrength()}`} />
                                </div>
                                <span className="strength-text">
                                    Force: {getPasswordStrength() === 'weak' ? 'Faible' :
                                        getPasswordStrength() === 'medium' ? 'Moyenne' : 'Fort'}
                                </span>
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        <label className="form-label" htmlFor="verify">
                            Confirmer le mot de passe
                        </label>
                        <input
                            type="password"
                            id="verify"
                            className="form-input"
                            placeholder="••••••••"
                            value={verify}
                            onChange={(e) => setVerify(e.target.value)}
                            required
                            autoComplete="new-password"
                        />
                    </div>

                    <button type="submit" className="auth-btn">
                        Créer mes accès
                    </button>
                </form>
            </div>

            <Loader show={loading} message="Création en cours..." />
        </div>
    );
}
